import updateTableReducer from './reducer';

export { default as updateTableSagas } from './sagas';
export { default as updateTableTypes } from './types';
export { default as updateTableActions } from './actions';

export default updateTableReducer;